
import AuthModule from '../../store/auth.module'
import SessionModule from '../../store/session.module'
import { defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n';
import exportFile from 'quasar/src/utils/export-file.js';import useQuasar from 'quasar/src/composables/use-quasar.js';
export default defineComponent({
  setup() {
    const { t } = useI18n({ useScope: 'global' })
    const q = useQuasar()
    const devices = ref([]);
    const debugLevels = [
      { label: 'ERROR', value: 'ERROR' },
      { label: 'WARN', value: 'WARN' },
      { label: 'INFO', value: 'INFO' },
      { label: 'DEBUG', value: 'DEBUG' },
      { label: 'TRACE', value: 'TRACE' }
    ];
    return {
      q,
      t,
      devices,
      debugLevels,
      columns: [
        { name: 'name', label: t('events.name'), field: 'name' },
        { name: 'devicenumber', label: t('session.numberofdevice'), field: 'devicenumber' },
        { name: 'starttimestring', label: t('events.starttime'), field: 'starttimestring' },
        { name: 'numberoftags', label: t('session.numberoftags'), field: 'numberoftags' },
        { name: 'debuglevel', label: t('session.debuglevel'), field: 'debuglevel' },
        { name: 'actions', label: '', field: '' }

      ],
    }
  },
  mounted() {
    if (!AuthModule.isLoggedIn)
      this.$router.push("/login")
    else
      this.getAllDevices();
  },
  methods: {
    async onDebugLevelChange(device: any) {
      try {
        const request = {
          token: AuthModule.currentUser.accessToken,
          id: device.devicenumber,
          level: device.debuglevel
        };

        await AuthModule.setDebugLevel(request);

        this.q.notify({
          message: this.t('session.debuglevelupdated'),
          color: 'positive',
          icon: 'check'
        });

      } catch (e) {
       /* this.q.notify({
          message: this.t('session.debuglevelerror'),
          color: 'negative',
          icon: 'warning'
        });*/
      }
    }
    ,
    async downloadLog(deviceid: any) {
      console.log('device=', deviceid)
      try {
        const request = {
          token: AuthModule.currentUser.accessToken,
          id: deviceid,
          logfile: ""
        };

        const response = await AuthModule.getDeviceLog(request)

        this.saveBase64Gzip(response);

        this.q.notify({
          message: this.t('tags.browserdownloaded'),
          color: 'positive',
          icon: 'download'
        });

      } catch (e) {
        this.q.notify({
          message: this.t('tags.browserdenied'),
          color: 'negative',
          icon: 'warning'
        });
      }
    },
    saveBase64Gzip(file: {
      filename: string;
      encoding: string;
      data: string;
    }) {
      if (file.encoding !== 'base64') {
        throw new Error('Unsupported encoding');
      }

      const binary = atob(file.data);
      const bytes = new Uint8Array(binary.length);

      for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
      }

      const blob = new Blob([bytes], { type: 'application/gzip' });

      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = file.filename || 'log.gz';
      document.body.appendChild(a);
      a.click();

      a.remove();
      URL.revokeObjectURL(url);
    },


    wrapCsvValue(val: string) {
      let formatted = val

      formatted = formatted === void 0 || formatted === null
        ? '' : String(formatted)
      formatted = formatted.split('"').join('""')
      return `"${formatted}"`
    },
    exportTable() {
      // naive encoding to csv format
      const content = [this.columns.map(col => this.wrapCsvValue(col.label))].concat(
        this.sessions.map(session => this.columns.map(col => this.wrapCsvValue(
          typeof col.field === 'function'
            ? col.field(session)
            : session[col.field === void 0 ? col.username : col.field]
        )).join(','))
      ).join('\r\n')

      const status = exportFile(
        'Sessions_' + new Date().toLocaleString() + '.csv',
        content,
        'text/csv'
      )

      if (status !== true) {
        this.q.notify({
          message: this.t('tags.browserdenied'),
          color: 'negative',
          icon: 'warning'
        })
      }
      else {
        this.q.notify({
          message: this.t('tags.browserdownloaded'),
          color: 'positive',
          icon: 'warning'
        })
      }
    },

    getAllDevices() {
      SessionModule.getAllDevicesAction();
      this.devices = SessionModule.getAllDevices
    }

  }
})
